enum TETRIS_SCREEN_TYPE {
  License = 'LICENSE',
  Title = 'TITLE',
  Gameplay = 'GAMEPLAY',
}

export { TETRIS_SCREEN_TYPE };
